<template>
  <v-container fluid grid-list-md class="pa-3">
    <v-progress-linear v-if="loadingSpin" indeterminate height="3" class="my-0"></v-progress-linear>
    <template v-else>
      <v-layout v-if="showStripA" row wrap>
        <v-flex v-for="k in stripA" :key="k.label" xs6 sm4 md2>
          <v-tooltip top :disabled="!k.tip">
            <v-card slot="activator" flat class="v2-card v2-kpi">
              <div class="v2-kpi-label">{{ k.label }}</div>
              <div class="v2-kpi-value success--text">{{ k.value | currency }}</div>
              <div v-if="k.caption" class="v2-kpi-caption">{{ k.caption }}</div>
            </v-card>
            <span>{{ k.tip }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <v-layout v-else row wrap>
        <v-flex xs12 sm4>
          <v-tooltip top>
            <v-card slot="activator" flat class="v2-card v2-kpi">
              <div class="v2-kpi-label">Total Portfolio Balance</div>
              <div class="v2-kpi-value success--text">{{ portfolio_balance.toFixed(2) | currency }}</div>
              <div v-if="mainSyndicate && mainSyndicate.show_cash_balance" class="v2-kpi-caption">
                Cash Balance: {{ currentSyndicate.cash_balance | currency }}
              </div>
            </v-card>
            <span>Total Portfolio Balance is the sum of the current remaining balances of your invested deals. Complete with Discount and Write-off deals are not included.</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card flat class="v2-card v2-kpi">
            <div class="v2-kpi-label">Net Investment</div>
            <div class="v2-kpi-value success--text">
              <template v-if="mainSyndicate && mainSyndicate.is_cash_balance">{{ netInvestmentNew | currency }}</template>
              <template v-else>{{ netInvestment().toFixed(2) | currency }}</template>
            </div>
            <div class="v2-kpi-caption">Total Investment Cost: {{ total_participation_cost.toFixed(2) | currency }}</div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card flat class="v2-card v2-kpi">
            <div class="v2-kpi-label">Portfolio Return</div>
            <div class="v2-kpi-value success--text">{{ portfolioReturn().toFixed(2) }}%</div>
            <div class="v2-kpi-caption">
              Total Payouts: {{ parseFloat(total_payouts).toFixed(2) | currency }} ({{ recent_payouts.pay_date }})
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <keep-alive>
        <router-view class="mt-3"></router-view>
      </keep-alive>

      <ResetPassword v-if="passwordDialog" :passwordDialog="passwordDialog" @closePasswordDialog="passwordDialog = false" />
    </template>
  </v-container>
</template>

<script>
import ResetPassword from '../../components/Dialogs/ResetPassword'
import user_helper from '../../helpers/user_helper'
import dashboardSums from '../mixins/dashboardSums'

export default {
  mixins: [user_helper, dashboardSums],
  components: { ResetPassword },
  data: () => ({
    passwordDialog: localStorage.getItem('first_login') == 'true',
  }),
  computed: {
    showStripA() {
      return this.$route.name != 'V2DashboardSimple' && !!(this.mainSyndicate && this.mainSyndicate.show_detailed_view_tab)
    },
    stripA() {
      const cards = [
        {
          label: 'Total Anticipated Return',
          value: this.total_syndication_part_rtr.toFixed(2),
          tip: 'Total Anticipated Return(right to receive) is the sum of the anticipated return on invested deals',
        },
        {
          label: 'Total Investment Cost (Sent in)',
          value: this.total_participation_cost.toFixed(2),
          tip: 'Total Investment Cost(Sent in) is the sum of all expenses (fee and/or commission) incurred when investing in deals',
        },
        {
          label: 'Portfolio Balance',
          value: this.portfolio_balance.toFixed(2),
          tip: 'Portfolio Balance is the sum of the current remaining balances of your invested deals. Complete with Discount and Write-off deals are not included.',
        },
        {
          label: 'Total Payouts',
          value: parseFloat(this.total_payouts).toFixed(2),
          tip: 'Total Payouts is the total amount of repayments that you have received',
        },
        {
          label: 'Latest Payout',
          value: parseFloat(this.recent_payouts.sum_net_pay).toFixed(2),
          caption: this.recent_payouts.pay_date,
        },
      ]
      if (this.mainSyndicate && this.mainSyndicate.is_cash_balance) {
        cards.push({ label: 'Cash Balance', value: this.currentSyndicate.cash_balance })
      }
      return cards
    },
  },
}
</script>
